<div class="checkout-gateway-priority-settings">
  <div class="page-header">
    <div class="page-title">Ordem Gateway Checkout | Novas assinaturas</div>
    <p class="page-description">
      Define qual gateway de cartão tenta <strong>primeiro</strong> e qual fica de
      <strong>fallback</strong> nas <strong>novas assinaturas</strong>
      (aquisição e reativação).
    </p>
    <div class="fallback-note">
      <i class="pi pi-info-circle"></i>
      <span>
        Se a configuração estiver indisponível, a API usa a ordem de segurança
        definida no ambiente.
      </span>
    </div>
  </div>

  <div class="config-card">
    <div class="config-card__header">
      <div>
        <h2>Prioridade de cobrança</h2>
        <p>Escolha a sequência usada durante o processamento do pagamento.</p>
      </div>
    </div>

    <div class="gateway-flow">
      <div class="gateway-position">
        <div class="gateway-position__label">
          <span class="priority-number">1</span>
          Gateway primário
        </div>
        <small>Primeira tentativa de cobrança</small>
        <div class="gateway-position__value">
          <i class="pi pi-credit-card"></i>
          <strong>{{ primaryGatewayLabel }}</strong>
        </div>
      </div>

      <div class="invert-action">
        <p-button
          label="Inverter ordem"
          icon="pi pi-arrow-right-arrow-left"
          severity="secondary"
          [outlined]="true"
          (onClick)="invertOrder()"
          [disabled]="
            saving ||
            primaryGatewayId === null ||
            secondaryGatewayId === null
          "
        />
      </div>

      <div class="gateway-position">
        <div class="gateway-position__label">
          <span class="priority-number">2</span>
          Gateway secundário
        </div>
        <small>Fallback se a primeira tentativa não for aprovada</small>
        <div class="gateway-position__value">
          <i class="pi pi-credit-card"></i>
          <strong>{{ secondaryGatewayLabel }}</strong>
        </div>
      </div>
    </div>

    <div class="config-card__footer">
      <small *ngIf="lastUpdatedAt" class="config-card__updated">
        <i class="pi pi-clock"></i>
        Última atualização:
        {{ lastUpdatedAt | date: 'dd/MM/yyyy HH:mm' }}
        <span *ngIf="lastUpdatedBy"> por {{ lastUpdatedBy }}</span>
      </small>

      <p-button
        label="Salvar ordem"
        icon="pi pi-check"
        (onClick)="save()"
        [loading]="saving"
        [disabled]="saving"
      />
    </div>
  </div>
</div>
<p-toast />
